const processAssessment = async (url, abortController, token, payload) => {
  abortController.current = new AbortController();
  const options = {
    signal: abortController.current.signal,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    ...(payload ? { body: JSON.stringify(payload) } : {}),
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(
        `Failed to process assessment: ${JSON.stringify(errorResponse)} ${response.status}`
      );
    }
    return response.json();
  } catch (error) {
    throw new Error("Error while processing assessment", { cause: error });
  }
};

export default processAssessment;
